module.exports = __webpack_public_path__ + "static/media/Group 11111.b69be29c.svg";